import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_BRAND_NEWS_REQUEST = 'Brand/FETCH_BRAND_NEWS_REQUEST'
const FETCH_BRAND_NEWS_SUCCESS = 'Brand/FETCH_BRAND_NEWS_SUCCESS'
const FETCH_BRAND_NEWS_FAILURE = 'Brand/FETCH_BRAND_NEWS_FAILURE'

const FETCH_BRAND_NEWS_BY_ID_REQUEST = 'Brand/FETCH_BRAND_NEWS_BY_ID_REQUEST'
const FETCH_BRAND_NEWS_BY_ID_SUCCESS = 'Brand/FETCH_BRAND_NEWS_BY_ID_SUCCESS'
const FETCH_BRAND_NEWS_BY_ID_FAILURE = 'Brand/FETCH_BRAND_NEWS_BY_ID_FAILURE'

const CREATE_BRAND_NEWS_REQUEST = 'Brand/CREATE_BRAND_NEWS_REQUEST'
const CREATE_BRAND_NEWS_SUCCESS = 'Brand/CREATE_BRAND_NEWS_SUCCESS'
const CREATE_BRAND_NEWS_FAILURE = 'Brand/CREATE_BRAND_NEWS_FAILURE'

const UPDATE_BRAND_NEWS_REQUEST = 'Brand/UPDATE_BRAND_NEWS_REQUEST'
const UPDATE_BRAND_NEWS_SUCCESS = 'Brand/UPDATE_BRAND_NEWS_SUCCESS'
const UPDATE_BRAND_NEWS_FAILURE = 'Brand/UPDATE_BRAND_NEWS_FAILURE'

const DELETE_BRAND_NEWS_REQUEST = 'Brand/DELETE_BRAND_NEWS_REQUEST'
const DELETE_BRAND_NEWS_SUCCESS = 'Brand/DELETE_BRAND_NEWS_SUCCESS'
const DELETE_BRAND_NEWS_FAILURE = 'Brand/DELETE_BRAND_NEWS_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  brandNewsList: [],
  brandNewsObj: {}
}

// Default Reducer
const brandNews = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_NEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandNewsList: action.payload
      }
    case FETCH_BRAND_NEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_BRAND_NEWS_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_NEWS_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandNewsObj: action.payload
      }
    case FETCH_BRAND_NEWS_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_BRAND_NEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_BRAND_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_BRAND_NEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BRAND_NEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BRAND_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BRAND_NEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BRAND_NEWS_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BRAND_NEWS_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BRAND_NEWS_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default brandNews

// Action Creators
export const fetchBrandNewsList = (brandId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BRAND_NEWS_REQUEST
      })

      const response = await API.get(EndPoints.BRAND_NEWS + `/brand/${brandId}`)
      dispatch({
        type: FETCH_BRAND_NEWS_SUCCESS,
        payload: response.data
      })
    } catch (err) {
      dispatch({
        type: FETCH_BRAND_NEWS_FAILURE
      })
    }
  }
}

export const createBrandNews = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BRAND_NEWS_REQUEST
      })

      await API.post(EndPoints.BRAND_NEWS, data)
      dispatch({
        type: CREATE_BRAND_NEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_BRAND_NEWS_FAILURE
      })
    }
  }
}

export const updateBrandNews = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BRAND_NEWS_REQUEST
      })

      await API.put(EndPoints.BRAND_NEWS, data)
      dispatch({
        type: UPDATE_BRAND_NEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BRAND_NEWS_FAILURE
      })
    }
  }
}

export const deleteBrandNews = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BRAND_NEWS_REQUEST
      })

      await API.delete(EndPoints.BRAND_NEWS + `/${id}`)
      dispatch({
        type: DELETE_BRAND_NEWS_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BRAND_NEWS_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/brandNews.js